import RequestOptions from 'owa-service/lib/RequestOptions';
import { getRequestOptionsOrDefault } from 'owa-headers-core';
import { MailboxInfo } from 'owa-client-ids';

export function getRequestOptionsOrDefaultV2(mailboxInfo: MailboxInfo): RequestOptions {
    return getRequestOptionsOrDefault(mailboxInfo);
}
